import Skeleton from "react-loading-skeleton";

const StoreInfoSkeleton = () => {
  return (
    <>
      <div className="mb-5">
        <div className="mb-4">
          <Skeleton
            count={1}
            width="40%"
            height="2.25rem"
            className="mr-2.5"
            inline
          />
          <Skeleton
            count={1}
            width="86px"
            inline
            height="2.25rem"
            borderRadius="50px"
          />
        </div>
        <Skeleton count={3} />
      </div>
    </>
  );
};

export default StoreInfoSkeleton;
